<template>
  <div>
    <router-view />
    <vuedal />
  </div>
</template>

<script>
import {Component as Vuedal} from 'vuedals';

export default {
  name: 'App',
  components: {Vuedal},
  created() {
    const currentPath = this.$router.history.current.path;

    if (window.localStorage.getItem('authenticated') === 'false') {
      this.$router.push('/login');
    }

    if (currentPath === '/' || currentPath === '/app') {
      this.$router.push('/app/dashboard');
    }
  },
};
</script>

<style src="./styles/theme.scss" lang="scss" />
